@if (shouldShowMedia() && hasAvailableMedia()) {
    @if (wireType() === MediaType.VIDEO) {
        <video
            controls
            class="st-wire-media__video"
            [src]="mediaUrl()"
            (click)="openMedia()"
            (error)="onMediaError()"
            (loadeddata)="onMediaLoaded()"></video>
    } @else {
        <img
            class="st-wire-media__image"
            fill
            [ngSrc]="mediaUrl()"
            (click)="openMedia()"
            (error)="onMediaError()"
            (load)="onMediaLoaded()" />
    }
}
